<script setup lang="ts">
import type { Props } from './Footer.types';

const props = withDefaults(defineProps<Props>(), {
  footerBgColor: '#6e6e6e',
});
</script>

<template>
  <div class="footer" :style="{ '--footer-bg-color': props.footerBgColor }">
    <div class="footer__container_top">
      <div class="footer__top">
        <slot name="footer-top" />
      </div>
    </div>
    <div class="footer__container_bottom">
      <div class="footer__bottom">
        <slot name="footer-bottom" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@shop/assets/scss/components/footer';
</style>
